import { api } from "./client";
import { Child } from "../types/gordost";

export interface CabinetMeResponse {
  parent: {
    id: number;
    email: string;
    display_name: string;
    phone: string | null;
    created_at: string;
    last_login_at: string | null;
  };
  children: Child[];
  current_year: { id: number; name: string } | null;
  reception_label: string | null;
}

export async function getCabinetMe(): Promise<CabinetMeResponse> {
  const { data } = await api.get("/cabinet/me");
  return data;
}

export interface CabinetYear {
  id: number;
  name: string;
  is_active: boolean;
}

/** Справочник учебных годов — для человекочитаемых подписей в архиве портфолио. */
export async function getCabinetYears(): Promise<CabinetYear[]> {
  const { data } = await api.get("/cabinet/years");
  return data;
}

export type InvitationStatus = "invited" | "not_invited" | "pending";

export interface YearSummary {
  student_id: number;
  student_name: string;
  student_class: string | null;
  year_id: number;
  year_name: string;
  reception_label: string;
  approved_count: number;
  spheres: { type: string; count: number }[];
  is_letopisec: boolean;
  invitation_status: InvitationStatus;
  nomination: { title: string; icon: string | null } | null;
}

/** Данные экрана «Сводка года» (D4): достижения по сферам + статус приглашения. */
export async function getYearSummary(
  student_id: number,
  year_id?: number,
): Promise<YearSummary> {
  const { data } = await api.get("/cabinet/year-summary", {
    params: { student_id, year_id },
  });
  return data;
}

export interface AddChildResponse {
  ok: boolean;
  student_id: number;
  already_linked?: boolean;
}

export async function addChild(code: string): Promise<AddChildResponse> {
  const { data } = await api.post("/cabinet/add-child", { code: code.toUpperCase() });
  return data;
}

export interface DeleteAccountResponse {
  ok: boolean;
  deleted_posts: number;
}

export async function deleteAccount(password: string): Promise<DeleteAccountResponse> {
  const { data } = await api.post("/cabinet/delete-account", { password });
  return data;
}

export interface ChangePasswordResponse {
  ok: boolean;
}

export async function changePassword(
  old_password: string,
  new_password: string
): Promise<ChangePasswordResponse> {
  const { data } = await api.post("/cabinet/change-password", {
    old_password,
    new_password,
  });
  return data;
}
